<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">社会保障</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goApply">
        <div class="module_left">电子社保卡申领</div>

        <div class="module_right_icon1 Apply1">
          <div class="module_right_icon2 Apply2">
            <div class="module_right_icon3 Apply3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goAuthentication">
        <div class="module_left">养老待遇资格认证</div>

        <div class="module_right_icon1 Authentication1">
          <div class="module_right_icon2 Authentication2">
            <div class="module_right_icon3 Authentication3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goRetirement">
        <div class="module_left w220">城乡居民养老保险待遇申请</div>

        <div class="module_right_icon1 Retirement1">
          <div class="module_right_icon2 Retirement2">
            <div class="module_right_icon3 Retirement3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goQuery">
        <div class="module_left w220">养老保险待遇发放明细查询</div>

        <div class="module_right_icon1 Query1">
          <div class="module_right_icon2 Query2">
            <div class="module_right_icon3 Query3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goResident">
        <div class="module_left">城乡居民养老保险缴费</div>

        <div class="module_right_icon1 Resident1">
          <div class="module_right_icon2 Resident2">
            <div class="module_right_icon3 Resident3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goTemporary">
        <div class="module_left">社保卡临时挂失</div>

        <div class="module_right_icon1 Temporary1">
          <div class="module_right_icon2 Temporary2">
            <div class="module_right_icon3 Temporary3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    async goApply() {
      this.$router.push({
        path: "/society/apply/index",
      });
    },
    async goAuthentication() {
      this.$router.push({
        path: "/society/authentication/index",
      });
    },
    async goResident() {
      this.$router.push({
        path: "/society/resident/index",
      });
    },
    async goQuery() {
      this.$router.push({
        path: "/society/Query/index",
      });
    },
    async goRetirement() {
      this.$router.push({
        path: "/society/retirement/index",
      });
    },
    async goTemporary() {
      this.$router.push({
        path: "/society/temporary/index",
      });
    },
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
  },
};
</script>

<style scoped lang="less">
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 绿色 */
  background: linear-gradient(
    180deg,
    rgb(0, 189, 141),
    rgb(23, 211, 162) 26.718%,
    rgb(227, 255, 231) 100%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 50px;
    top: 40px;
    z-index: 0;
    width: 340px;
    height: 245px;
    background: url(@/assets/society/societyIndex/society_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 340px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 35px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 180px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .w220 {
      width: 220px;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
  .Apply1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Apply2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Apply3 {
    background: url("@/assets/society/societyIndex/apply.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Authentication1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Authentication2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Authentication3 {
    background: url("@/assets/society/societyIndex/authentication.png")
      no-repeat center;
    background-size: 100% 100%;
  }
  .Retirement1 {
    background: url("@/assets/colorBg/pink1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Retirement2 {
    background: url("@/assets/colorBg/pink2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Retirement3 {
    background: url("@/assets/society/societyIndex/retirement.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Query1 {
    background: url("@/assets/colorBg/orange1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Query2 {
    background: url("@/assets/colorBg/orange2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Query3 {
    background: url("@/assets/society/societyIndex/query.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Resident1 {
    background: url("@/assets/colorBg/purple1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Resident2 {
    background: url("@/assets/colorBg/purple2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Resident3 {
    background: url("@/assets/society/societyIndex/resident.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Temporary1 {
    background: url("@/assets/colorBg/red1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Temporary2 {
    background: url("@/assets/colorBg/red2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Temporary3 {
    background: url("@/assets/society/societyIndex/temporary.png") no-repeat
      center;
    background-size: 100% 100%;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
</style>
